import { configureStore } from '@reduxjs/toolkit';

import ownerAuthReducer from '@main/features/auth/ownerAuthSlice';
import branchesReducer from '@main/features/branches/branchesSlice';
import ownerEventsReducer from '@main/features/events/ownerEventsSlice';
import settingsReducer from '@main/features/settings/settingsSlice';

import crmAuthReducer from '@crm/features/auth/crmAuthSlice';
import crmClientsReducer from '@crm/features/clients/clientsSlice';
import crmManagersReducer from '@crm/features/managers/managersSlice';
import crmDirectionsReducer from '@crm/features/directions/directionsSlice';
import crmGoodsReducer from '@crm/features/goods/goodsSlice';
import crmExpendituresReducer from '@crm/features/expenditures/expendituresSlice';
import crmSalesReducer from '@crm/features/sales/salesSlice';
import crmPaymentsReducer from '@crm/features/payments/paymentsSlice';
import crmCalendarReducer from '@crm/features/calendar/calendarSlice';
import crmOverviewReducer from '@crm/features/overview/overviewSlice';
import crmEventsReducer from '@crm/features/events/eventsSlice';

import uiReducer from '@shared/slices/uiSlice';
import notificationPushReducer from '@shared/slices/notificationPushSlice';

export const store = configureStore({
  reducer: {
    ownerAuth: ownerAuthReducer,
    branches: branchesReducer,
    ownerEvents: ownerEventsReducer,
    settings: settingsReducer,

    crmAuth: crmAuthReducer,
    crmClients: crmClientsReducer,
    crmManagers: crmManagersReducer,
    crmDirections: crmDirectionsReducer,
    crmGoods: crmGoodsReducer,
    crmExpenditures: crmExpendituresReducer,
    crmSales: crmSalesReducer,
    crmPayments: crmPaymentsReducer,
    crmCalendar: crmCalendarReducer,
    crmOverview: crmOverviewReducer,
    crmEvents: crmEventsReducer,

    ui: uiReducer,
    notificationPush: notificationPushReducer,
  },
  middleware: (getDefault) => getDefault({ thunk: true }),
});
